<rotec-modal-v2 [title]="title" [width]="width" [darkMode]="true">
  <ng-container ngProjectAs="modal-main">
    <div class="location-modal-content">
      <div class="location-item">
        <div class="label">
          {{ 'Angle' | translate }}
          <rotec-icon-v2 class="required-icon" svgIcon="union" color="pink"></rotec-icon-v2>
        </div>
        <rotec-number-input-v2
          [formControl]="locationForm.get('angle')"
          info="°"
          [autofocus]="true"
          min="0"
          max="360"
          darkMode="true"
          (valueChange)="onChangeForm($event, 'angle')"
        ></rotec-number-input-v2>
        @if (locationForm.get('angle').errors) {
          <div class="error-message">
            {{ getAngleErrorMessage(locationForm.get('angle').errors.valueRangeError) | translate }}
          </div>
        }
      </div>
      @if (enableRadius) {
        <div class="location-item">
          <div class="label">{{ 'Correction Radius' | translate }}</div>
          <rotec-number-input-v2
            [formControl]="locationForm.get('correctionRadius').get('value')"
            unitType="Length"
            [selectedUnit]="locationForm.get('correctionRadius').value?.unit"
            [required]="true"
            [hasError]="locationForm.errors || locationForm.get('correctionRadius').errors"
            darkMode="true"
            (valueChange)="onChangeForm($event, 'correctionRadius')"
          ></rotec-number-input-v2>
          @if (locationForm.get('correctionRadius').errors) {
            <div class="error-message">
              {{ locationForm.get('correctionRadius').errors.radiusError | translate }}
            </div>
          }
        </div>
      }
      <div class="location-item">
        <div class="label">{{ 'Restricted' | translate }}</div>
        <rotec-checkbox-v2
          [status]="restrictedValue"
          (statusChange)="restrictedValue = $event"
        ></rotec-checkbox-v2>
      </div>
    </div>
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    <div class="location-modal-buttons">
      <button rotec-button-primary-v2 dark (click)="cancel()">
        {{ 'Cancel' | translate }}
      </button>
      @if (showDeleteButton) {
        <button class="delete-location" rotec-button-warning dark (click)="deleteLocation()">
          {{ 'Delete' | translate }}
        </button>
      }
      <button rotec-button-active dark [disabled]="!locationForm.valid" (click)="save()">
        {{ 'Save' | translate }}
      </button>
    </div>
  </ng-container>
</rotec-modal-v2>
